module.exports = __webpack_public_path__ + "media/img/super-venue/benefits2-377d743a16162254a06e766d2f5fa76a.png";